/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRoleAssignedUserDto
 */
export interface GetRoleAssignedUserDto {
    /**
     * User ID
     * @type {string}
     * @memberof GetRoleAssignedUserDto
     */
    id: string;
    /**
     * User name
     * @type {string}
     * @memberof GetRoleAssignedUserDto
     */
    name: string;
    /**
     * User email
     * @type {string}
     * @memberof GetRoleAssignedUserDto
     */
    email: string;
    /**
     * User phone number
     * @type {string}
     * @memberof GetRoleAssignedUserDto
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the GetRoleAssignedUserDto interface.
 */
export function instanceOfGetRoleAssignedUserDto(value: object): value is GetRoleAssignedUserDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function GetRoleAssignedUserDtoFromJSON(json: any): GetRoleAssignedUserDto {
    return GetRoleAssignedUserDtoFromJSONTyped(json, false);
}

export function GetRoleAssignedUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRoleAssignedUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
    };
}

export function GetRoleAssignedUserDtoToJSON(json: any): GetRoleAssignedUserDto {
    return GetRoleAssignedUserDtoToJSONTyped(json, false);
}

export function GetRoleAssignedUserDtoToJSONTyped(value?: GetRoleAssignedUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
    };
}

